/**
 * TGH Senior Center — Conditions marquee
 * Clones each row's track until it covers the viewport twice, then the CSS
 * keyframes (translateX -100% per track) give a seamless infinite loop.
 * Speed is in px/second (data-speed), so it stays constant at any width.
 * Pauses when the block is off-screen.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupRow(row) {
    var original = row.querySelector('.tgh-marquee__track');
    if (!original) return;

    row.querySelectorAll('.tgh-marquee__track[aria-hidden="true"]').forEach(function (clone) {
      clone.remove();
    });

    var setWidth = original.getBoundingClientRect().width;
    if (!setWidth) return;

    var copies = Math.max(1, Math.ceil(row.clientWidth / setWidth));
    for (var i = 0; i < copies; i++) {
      var clone = original.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('img').forEach(function (img) { img.alt = ''; });
      row.appendChild(clone);
    }

    var speed = parseFloat(row.getAttribute('data-speed')) || 40;
    row.style.setProperty('--tgh-marquee-duration', (setWidth / speed).toFixed(2) + 's');
  }

  function init() {
    document.querySelectorAll('[data-tgh-marquee]').forEach(function (marquee) {
      if (marquee.dataset.tghReady) return;
      marquee.dataset.tghReady = '1';

      var rows = Array.prototype.slice.call(marquee.querySelectorAll('[data-tgh-marquee-row]'));
      var lastWidth = 0;

      function build() {
        if (marquee.clientWidth === lastWidth) return;
        lastWidth = marquee.clientWidth;
        rows.forEach(setupRow);
        marquee.classList.toggle('is-ready', !reduceMotion.matches);
      }

      if (document.readyState === 'complete') build();
      else window.addEventListener('load', build, { once: true });
      build();

      var timer = 0;
      window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(build, 200);
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            marquee.style.setProperty('--tgh-marquee-state', entry.isIntersecting ? 'running' : 'paused');
          });
        }).observe(marquee);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/conditions.js